/**
 * enterprise.features is historically a string[] (`["locations"]`) and
 * newer writers (3pl / finished_goods) may persist an object map
 * (`{ locations: true, "3pl": true }`).
 *
 * Theme allowlists MUST NOT live under features — use top-level
 * `enterprise.allowedThemes`. Nesting them (or converting array features
 * to an object) previously crashed Promise admin: layout selectors called
 * `(features || []).includes(...)` and TypeError took down the shell.
 *
 * Always use this helper instead of raw `.includes` on features.
 */
export function enterpriseHasFeature(enterprise, key) {
  const features = enterprise?.features;
  if (Array.isArray(features)) return features.includes(key);
  if (features && typeof features === "object") {
    const value = features[key];
    // Arrays nested under features (e.g. stale allowedThemes) are not flags.
    if (Array.isArray(value)) return false;
    return !!value;
  }
  return false;
}
